var path = 'jangl/jangl-errors/template.html';
var html = "<div ng-show=$ctrl.errors.length> <div class=\"well form-errors\" ng-if=$ctrl.errors.length> <h2>Errors!</h2> <hr/> <p> We found these errors on your submission: </p><ul> <li id=error-{{$index}} ng-repeat=\"$errors in $ctrl.errors\"> <span ng-repeat=\"($fieldError, $errorDescription) in $errors\"><strong>{{$fieldError}}</strong>: {{$errorDescription}}</span> </li> </ul> <p></p> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-errors/template.html
// module id = 383
// module chunks = 0